import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { SelectorFieldResult } from '../selector-field';

Component('tr-assignee-select-field-result', {
  mixins: [eventListenerMixin],

  extends: [SelectorFieldResult],

  properties: {
    avatarSelector: {
      type: String,
      default: 'img.avatar',
    },
    nicknameSelector: {
      type: String,
      default: '.nickname',
    },
    noAssignee: {
      type: Boolean,
      default: false,
    },
  },

  setSelectedResult(option) {
    if (option === false || option.value === 'no-assignee') {
      this.noAssignee = true;
    } else {
      this.noAssignee = false;
      const avatar = this.querySelector(this.avatarSelector);
      const nickname = this.querySelector(this.nicknameSelector);

      avatar.setAttribute('src', option.data.avatar);
      nickname.innerText = option.text;
    }
  },
});
